import BaseLayer from "./BaseLayer";
import {drawCircle, imagetoCanvasPosHelper} from "../utils/map_utils";
import {getPrefixedUrl} from "../../../utils/utils";
import {Stack} from "@mui/material";

class ZDropUnits extends BaseLayer {
    id = "zDropUnits";
    label = "Z-Drop Units";
    defaultVisible = this.props.tileViewerState[this.id];

    onFeatureSelect = () => undefined;

    draw = () => new Promise((resolve, reject) => {
        let {slide, zDropUnits, deviceSettings, textSize} = this.props;
        let {loc_on_machine, bucket_name, tile_viewer_path, uperpixel, tile_width, tile_height} = slide

        if (zDropUnits !== undefined 
            && zDropUnits["zdropUnits"] !== undefined 
            && zDropUnits["focusValueChangeThreshold"] !== undefined) {
            console.log("zDropUnits is ", zDropUnits);
            // sample zDropUnit is 
            /*
            {
                "morphleID": "1_2023-04-05_12-24-41-0000066_Tilda101_S2T1R1",
                "scanImageCellKey": "x1y4",
                "streakBestFocusedImagePath": "/media/scandrive/scans/morphle_test/2023/04/05/12/24/1_2023-04-05_12-24-41-0000066_Tilda101_S2T1R1/debug/zprofile/1_island_1001_fu_104/0_1001_x1y5_(18531.000,94891.000)_DOWN_pos_0/focused_0_-1797.637.jpg",
                "countyKey":
                {
                    "islandKey":
                    {
                        "takeNumber": 0,
                        "islandId": 1
                    },
                    "countyId": 1
                },
                "focusValueChange": 1.1041085880260415,
                "commonArea": 75
            },
             */
            const focusValueChangeThreshold = zDropUnits["focusValueChangeThreshold"];
            console.log("z drop focusValueChangeThreshold is", focusValueChangeThreshold);
            for (var zDropUnit of zDropUnits["zdropUnits"]) {
                console.log("zDropUnit is ", zDropUnit);
                var scanImageCellKey = zDropUnit["scanImageCellKey"];
                const focusValueChange = zDropUnit["focusValueChange"];
                const commonArea = zDropUnit["commonArea"];
                const morphleID = zDropUnit["morphleID"];
                const streakBestFocusedImagePath = zDropUnit["streakBestFocusedImagePath"];

                const xHori = parseInt(scanImageCellKey.split('y')[0].split('x')[1]);
                const yVerti = parseInt(scanImageCellKey.split('y')[1]);
                let scanImagePoint = imagetoCanvasPosHelper({device_settings: deviceSettings}, slide, slide.x_fields - xHori, yVerti);

                let linkToCrops = "app://" + loc_on_machine + "/scans/" + bucket_name + "/" + tile_viewer_path + "/debug/focus_val_compare/scan_ck_" + scanImageCellKey + "/crop/";
                let linkToStreakBestFocusedImage = getPrefixedUrl(streakBestFocusedImagePath.split(morphleID)[1], this.props.slide);

                let elems = [];
                elems.push(<a
                    href={linkToCrops}>{"F-value % change " + Math.round(focusValueChange * 100.0) / 100}</a>);
                elems.push(<a href={linkToStreakBestFocusedImage}
                              target={"_blank"}>{"[Streak Best Focused Image]"}</a>);
                elems.push(<p>{"Scan Image CellKey " + scanImageCellKey}</p>);
                elems.push(<p>{"Common Area % " + commonArea}</p>);
                elems.push(<p>{"F-value % Change Thresh " + focusValueChangeThreshold}</p>);
                let popupText = (
                    <Stack>
                        {elems}
                    </Stack>
                );
                let useOrange = focusValueChange > focusValueChangeThreshold ? true : false;
                let orangeColor = "#ff8c00";
                let greenColor = "#39FF14";
                let textColor = useOrange ? orangeColor : greenColor;
                drawCircle(scanImagePoint.x + 0.75 * tile_height * uperpixel, scanImagePoint.y - 0.35 * tile_width * uperpixel, 
                    55, this.layer.getSource(), "", 8, textColor, popupText,
                    textColor);
            }
        }
        resolve();
    });
}

export default ZDropUnits;